define('constants/scrollEventSources',[], function() {
    return {
        analytics: "analytics",
        inboxRecordings: "inboxRecordings",
        inboxVoicemails: "inboxVoicemails",
        receptionistMessages: "receptionistMessages",
        settingsAudioFiles: "settingsAudioFiles",
        settingsAutoAttendants: "settingsAutoAttendants",
        settingsForwardingNumbers:"settingsForwardingNumbers",
        settingsPhoneNumbers: "settingsPhoneNumbers",
        settingsExtensions: "settingsExtensions",
        settingsLiveReceptionistScripts: "settingsLiveReceptionistScripts",
        settingsSchedules: "settingsSchedules",
        settingsWebChatWidgets: "settingsWebChatWidgets"
    };
});
